var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "modal",
      staticClass: "fullpage-modal primary-background secondary-text",
      class: { open: _vm.openClass },
      style: { display: _vm.display },
      attrs: {
        "aria-hidden": !_vm.value,
        role: "dialog",
        "aria-modal": "true"
      },
      on: {
        transitionend: function($event) {
          return _vm.onTransitionEnd()
        }
      }
    },
    [
      _vm._t("header", [
        _c(
          "div",
          { staticClass: "fullpage-modal__header" },
          [
            _vm._t("logo", [_c("logo", { attrs: { disableFocus: "" } })]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "d-none d-md-inline-block round-icon-button secondary-background",
                attrs: { type: "button", "aria-label": _vm.closeLabel },
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_c("span", { staticClass: "icon-close primary-text" })]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "d-md-none round-icon-button primary-background",
                attrs: { type: "button", "aria-label": _vm.closeLabel },
                on: {
                  click: function($event) {
                    return _vm.close()
                  }
                }
              },
              [_c("span", { staticClass: "icon-close secondary-text" })]
            ),
            _vm._v(" "),
            _c("logo", {
              staticStyle: { visibility: "hidden" },
              attrs: { disableFocus: "" }
            })
          ],
          2
        )
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "fullpage-modal__container py-5" },
        [
          _vm.topIcon
            ? _c("arrow-icon", { attrs: { direction: "top" } })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              ref: "contentContainer",
              staticClass: "fullpage-modal__content",
              on: {
                scroll: function($event) {
                  return _vm.updateHeightAndPosition()
                }
              }
            },
            [_vm._t("default")],
            2
          ),
          _vm._v(" "),
          _vm.bottomIcon
            ? _c("arrow-icon", { attrs: { direction: "bottom" } })
            : _vm._e()
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }